/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Dont_Have_AccountInputs */

const en_auth_dont_have_account = /** @type {(inputs: Auth_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

const es_auth_dont_have_account = /** @type {(inputs: Auth_Dont_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No tienes una cuenta?`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Auth_Dont_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_dont_have_account = /** @type {((inputs?: Auth_Dont_Have_AccountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Dont_Have_AccountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_dont_have_account(inputs)
	return en_auth_dont_have_account(inputs)
});